// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { CircleX as RawCircleX } from "lucide-react";
export const CircleX = /* @__PURE__ */ createIcon(RawCircleX, "CircleX", 2);
